<template>
    <div class="consumers-create">
        <h1>Adicionar Federação</h1>
        <form @submit.prevent="createCompany">
            <InputContent label="Nome" v-model="name" />
            <InputContent label="Email" v-model="email" />

            <FileInput label="Logotipo" :multiple="false" @change="addLogo" />
            <br>
            <div class="buttons">
                <button type="submit" class="button" v-if="name && email && logo">Criar</button>
                <router-link :to="{ name: 'ConsumersList' }">
                    <button type="button" class="button">Cancelar</button>
                </router-link>
            </div>
        </form>
    </div>
</template>

<script>
import InputContent from '@/components/inputs/Content.vue'
import FileInput from '@/components/inputs/File.vue'

export default {
    name: 'CompanyCreate',
    props: {},
    components: {
        FileInput,
        InputContent,
    },
    data() {
        return {
            name: "",
            email: "",
            logo: null,
        }
    },
    methods: {
        async createCompany() {
            try {
                this.$store.dispatch('consumers/create', {
                    name: this.name,
                    email: this.email,
                    logo: this.logo,
                })
                this.$router.push({ name: 'ConsumersList' });
            } catch (error) {
                console.log(error)
            }
        },
        addLogo(e) {
            this.logo = e.target.files[0]
        }
    },
    computed: {
        consumer() {
            return this.$store.getters['consumers/email'](this.email)
        },
    },

    watch: {
        consumer() {
            if (this.consumer == null) {
                return
            }
            this.$router.push({ name: 'ConsumerInfo', params: { id: this.consumer.id } });
        },
    },

    mounted() {}
}
</script>

<style lang="scss" scoped>
@import '@/assets/utilities/_variables.scss';

.consumers-create {
    display: flex;
    flex-direction: column;

    h1 {
        position: relative;
        text-align: left;
        color: var(--white);
    }

    form {
        background-color: var(--sidebar-bg-color);
        padding: 0 20px;
        border: 1px solid none;
        border-radius: 10px;
        box-shadow: 0 3px 6px rgba(var(--black), .16), 0 3px 6px rgba(var(--black), .23);

        label {
            input[type=file] {
                display: none;

                &+.label {
                    padding: 1rem;
                    border: 2px dashed;
                    border-radius: 10px;
                    width: fit-content;
                }
            }
        }

        .buttons {
            margin: 1rem 0;
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 1rem;
            width: 100%;

            .button {
                flex: 1;
                padding: .5rem;
                font-size: 18px;
                cursor: pointer;
                text-align: center;
                border: none;
                border-radius: 5px;
                background-color: var(--text-color);
                color: var(--white);
                transition: background-color 0.3s ease;

                &:hover {
                    background-color: var(--highlight-color, 10%);
                }

                &[type="button"] {
                    background-color: var(--text-second-color);

                    &:hover {
                        background-color: var(--text-darken-color)
                    }
                }
            }
        }
    }

}
</style>
